import { render, staticRenderFns } from "./infoProdotto.vue?vue&type=template&id=2e9a724f&scoped=true&"
import script from "./infoProdotto.vue.ts?vue&type=script&lang=ts&"
export * from "./infoProdotto.vue.ts?vue&type=script&lang=ts&"
import style0 from "./infoProdotto.vue?vue&type=style&index=0&id=2e9a724f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9a724f",
  null
  
)

export default component.exports